module.exports = __webpack_public_path__ + "static/media/features-tabs-icon-01.56f77940.svg";